import moment from "moment";
import i18n from "@/services/i18n";

export default {
    filters: {
        formatDateTime(date, isUTC = false) {
            if (!date) return "-";
           // moment.locale("ru");
           moment.locale(i18n.locale);

            let res = moment(date);
            if(isUTC){
                res.add(3, 'hours');
            }
            return res.format("D MMMM YYYY, в HH:mm");
        }
    }
}